import { Box, Typography } from "@mui/material";
export default function DocumentPreview({ file }) {
  if (!file)
    return (
      <Box flex={1} bgcolor="#888" display="flex" justifyContent="center">
        <Typography color="white" mt={5}>
          Select a document to preview
        </Typography>
      </Box>
    );
  if (file.type === "application/pdf") {
    return (
      <iframe
        src={URL.createObjectURL(file)}
        style={{ width: "100%", height: "100vh", border: "none" }}
        title="pdf"
      />
    );
  }
  return (
    <Box flex={1} display="flex" justifyContent="center">
      <img
        src={URL.createObjectURL(file)}
        alt="preview"
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    </Box>
  );
}
